const macPattern = /^([\dA-Fa-f]{2}-){5}([\dA-Fa-f]{2})$/;
const linkLabsMacPattern = /^[0-9a-fA-F]{9}$/;
export function isMac(mac: string): boolean {
  return macPattern.test(mac) || linkLabsMacPattern.test(mac);
}
